<template>
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Meta Keywords - Upravit <span class="utils__link--underlined text-primary">#{{ this.id }}</span></strong>
      </div>
      <action-tools :router-options="routerOptions"></action-tools>
    </div>
    <div class="card-body">
      <div class="table-operations">
        <language-tab></language-tab>
      </div>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
        label="Název"
          :validate-status="nameError() ? 'error' : ''"
          :help="nameError() || ''"
        >
          <a-input @change="handleChange" placeholder="Název" v-decorator="['mkd_name', {rules: [{max: 30, message: 'Název nemůže být delší než 30 znaků'}, {required: true, message: 'Název musí být vyplněn!'}]}]"/>
        </a-form-item>
        <div class="form-actions">
          <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Upravit</a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import LanguageTab from '@/components/MyComponents/LanguageTab'
import ActionTools from '@/components/MyComponents/ActionTools'
import { hasErrors } from '../../../services/forms'

export default {
  components: { ActionTools, LanguageTab },
  data: function () {
    return {
      hasErrors,
      loading: false,
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/meta-keywords',
          title: 'Seznam',
        },
      ],
      items: [],
      form: this.$form.createForm(this),
      id: this.$route.params.id,
    }
  },
  computed: {
    language: function () {
      return this.$store.getters['language/active']
    },
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('metaKeyword/put', { id: this.id, item: this.items })
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    handleChange(e) {
      let found = false
      this.items.some((value, key) => {
        if (value.lge_id === this.$store.getters['language/active']) {
          this.items[key] = { lge_id: this.$store.getters['language/active'], mkd_name: e !== undefined ? e.target.value : '' }
          found = true
          return true
        }
      })
      if (!found) {
        this.items.push(
          { lge_id: this.$store.getters['language/active'], mkd_name: e !== undefined ? e.target.value : '' },
        )
      }
    },
    handleInit() {
      this.$store.dispatch('metaKeyword/getOne', this.id)
        .then(() => {
          this.items.push(this.$store.getters['metaKeyword/currentLanguageDetail'])
          this.form.setFieldsValue({
            mkd_name: this.items.find(x => x.lge_id === this.$store.getters['language/active']).mkd_name,
          })
          this.form.validateFields()
        })
        .catch(() => {})
    },
    nameError() {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched('mkd_name') && getFieldError('mkd_name')
    },
    refreshComponent(id) {
      this.id = id
      this.items = []
    },
  },
  created() {
    if (this.language !== null && this.items.filter(x => x.lge_id === this.language).length === 0) {
      this.handleInit()
    }
  },
  watch: {
    language(newValue, oldValue) {
      if (newValue !== null) {
        if (this.items.filter(x => x.lge_id === newValue).length === 0) {
          this.handleInit()
        } else {
          this.form.setFieldsValue({
            mkd_name: this.items.find(x => x.lge_id === newValue).mkd_name,
          })
          this.form.validateFields()
        }
      }
    },
    '$route.params.id'(newId, oldId) {
      this.refreshComponent(newId)
      if (this.language !== null) {
        this.handleInit()
      }
    },
  },
}
</script>
